<template>
    <footer class="bg-gray-900 text-gray-300 py-10">
      <div class="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-10 md:text-center">
        
        <!-- Logo e Descrição -->
        <div>
            <img src="/img/logo-branco.png" alt="Criando Para Web" class="h-12 m-auto">
          <p class="mt-2 text-gray-400">
            Ajudamos empresas a crescer com estratégias inteligentes de tráfego pago.
          </p>  
          <p>Campinas/SP</p>
        </div>
  
        <!-- Links Rápidos -->
        <div>
          <h3 class="text-lg font-semibold text-white">Links Rápidos</h3>
          <ul class="mt-2 space-y-2">
            <li><a href="#benefits" class="hover:text-blue-400">Benefícios</a></li>
            <li><a href="#services" class="hover:text-blue-400">Serviços</a></li>
            <li><a href="#cta" class="hover:text-blue-400">Contato</a></li>
          </ul>
        </div>
  
        <!-- Contato e Redes Sociais -->
        <div>
          <h3 class="text-lg font-semibold text-white">Contato</h3>
          <p class="text-gray-400">✉ contato@criandoparaweb.com.br</p>

        </div>
        
      </div>
  
      <!-- Copyright -->
      <div class="mt-10 text-center text-gray-500 text-sm">
        &copy; {{ new Date().getFullYear() }} Criando Para Web. Todos os direitos reservados.
      </div>
    </footer>
  </template>
  